import { Store } from "pullstate";

export const AccountStore = new Store({
    account: {},
    activity: [],
    balances: [],
    currentActivity: {},
    cursor: new Date().toISOString(),
    openModal: false
});